module.exports = __webpack_public_path__ + "static/media/ctb.761f5cfc.jpg";